const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    transaction: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {
       
        case 'TRANSACTION_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                transaction: action.payload
        };
      
        case 'TRANSACTION_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                transaction: action.payload,
            };
        case 'PAIR_CURRENT_TRANSACTION':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                transaction: action.payload
            };  
            
        case 'TRANSACTION_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}
